import { Component, OnInit } from '@angular/core';
import {FormGroup,FormControl,Validators} from '@angular/forms';
import { LoadService } from '../../services/load.service';
import { PalletsService } from '../../services/pallets.service';
import { StockService } from '../../services/stock.service';

@Component({
  selector: 'app-reimprimirpallet',
  templateUrl: './reimprimirpallet.component.html',
  styleUrls: ['./reimprimirpallet.component.css']
})
export class ReimprimirpalletComponent implements OnInit {
public formCodigo:FormGroup;
public myAngularxQrCode: string;
public codigoPallet:string;
public cliente:string;
public habilitar:boolean;
public alert:string;
public isopen:boolean;
  constructor(private _loaddata:LoadService, private _palletsService:PalletsService, private _stockService:StockService) {
    this.myAngularxQrCode = 'P19-0000-1-';
    this.codigoPallet = 'P19-0000-1';
    this.cliente = 'Cliente';
    this.habilitar = false;
    this.alert = '';
    this.isopen = false;
  }

  ngOnInit() {
    this.formCodigo = new FormGroup({
      'codigo': new FormControl('',Validators.required)
    });
  }

  onEnter(){
    let qr = this.formCodigo.get('codigo').value;
    this.restablecerQR();
    this.borrarFormulario();


    if(qr != null && qr != ''){
      this.alert = "Buscando Pallet...";
      this.isopen = true;
      this._loaddata.loadChange(40);
      let variable = '';
      let guion = 0;
      let prefijopallet = '';
      let sufijocaja = '';
      let prefijo = 0;
      let sufijo = 0;

      /*Derrepente la pistola lee 3 caracteres raros*/
      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      /*P18-0000-131-*/
      let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
      if(regexp.test(qr)){
        for(var char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            variable += '-';
            guion = 1;
          }
          else if(guion == 1){
            prefijopallet = variable;
            variable = '';
            guion = 2;
          }
          else if (guion == 2){
            sufijocaja = variable;
            variable = '';
            guion = 3
          }
        }

        this._palletsService.getOneByNumber(prefijopallet+'-'+sufijocaja).subscribe(
          (response:any) => {
            console.log("respuesta del pallet: ", response);
            if(response.data.length !=0){
              this.codigoPallet = response.data[0].attributes.number;
              this.myAngularxQrCode = response.data[0].attributes.qr_code;
              this._loaddata.loadChange(60);
              this.isopen = true;
              this.alert = 'Obteniendo Datos...';
              this._stockService.getAllStockFromPallet(response.data[0].id).subscribe(
                (response:any) => {

                  console.log("Cajas del Pallet: ", response);
                  this.cliente = response.data[0].relationships.tag.data.relationships.production_order.data.attributes.client;
                  this.habilitar = true;
                  this.borrarFormulario();
                  this._loaddata.loadChange(100);
                  this.alert = 'Pallet Encontrado';
                  this.onClosedAutomatic();
                },
                (error) => {
                  console.log("Error: ",error.error.error);
                }
              );
            }
            else{
              this.alert = "No existe el pallet "+prefijopallet+'-'+sufijocaja+" en el sistema.";
              this.isopen = true;
              this._loaddata.loadChange(100);
              this.onClosedAutomatic();
            }

            // if(response.data.length == 0){
            //   this.alert = "No existe el pallet "+prefijopallet+'-'+sufijocaja+" en el sistema.";
            //   this.isopen = true;
            //   this._loaddata.loadChange(100);
            // }
            // else{
            //
            //   //this.generatePackingPallet(response.data[0].id);
            // }
          },
          (error) => {
            console.log("Error: ",error.error.error);
          }
        );
      }
    }
  }

  onPaste(){
    console.log("si pescó")
    let that = this;
    that.onEnter();
  }

  borrarFormulario(){
    this.formCodigo.reset();
    this.formCodigo.setValue({
      'codigo':''
    });
  }

  restablecerQR(){
    this.myAngularxQrCode = 'P19-0000-1-';
    this.codigoPallet = 'P19-0000-1';
    this.cliente = 'Cliente';
    this.habilitar = false;
  }

  onClosedAutomatic(){
    setTimeout(()=>{
      this.isopen = false;
    },3000);
  }

  onClosed(){
    this.isopen = false;
  }

  /**
  * Abre una nueva ventana para imprimir las etiquetas QR contenidas
  * en printContents, que a su vez esta relacionado con print-section del html.
  */
  public print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
      <style></style>
      </head>
      <body onload="window.print();window.close()">
      ${printContents}
      </body>
      </html>`
    );
    popupWin.document.close();
    this.borrarFormulario();
    this.restablecerQR();
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/reimprimirpallet/reimprimirpallet.component.ts